<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="projects-list">
        <div
          class="project-box"
          v-for="detalle in dataTable.results"
          :key="detalle.id"
          @click="rowClick(detalle)"
        >
          <div
            class="project-head"
            style="padding-rigth: 1em; padding-left: 1em"
          >
            <div class="project-title">
              <div
                class="badge"
                v-bind:class="{
                  'badge-success': detalle.estado_str == 'Abierto',
                  'badge-dark': detalle.estado_str == 'Cerrado',
                  'badge-danger': detalle.estado_str == 'Anulado',
                }"
              >
                {{ detalle.estado_str }}
              </div>
              <h5>#{{ detalle.numero }}</h5>
              <small>
                {{
                  detalle.fecha_creacion | moment("DD/MM/YYYY HH:mm:ss")
                }}</small
              >
              <div class="font-weight-bold" v-if="detalle.tienda">
                {{ detalle.tienda.nombre }}
              </div>
              <small> Caja: {{ detalle.caja.caja }}</small>
              <br />
              <small> Serie: {{ detalle.caja.serie_nota }}</small>
            </div>
          </div>
          <div class="project-info">
            <div class="row align-items-center">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-6">
                    <div class="el-tablo highlight">
                      <div class="label">Total facturado</div>
                      <h5 style="color: green">
                        {{ detalle.valor_total_cargo }}
                      </h5>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="el-tablo highlight">
                      <div class="label">Total Devuelto</div>
                      <h5 style="color: green">
                        {{ detalle.valor_total_devuelto }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  props: ["dataTable"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
    let self = this;
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "wms-envio-devolucion-mayoreo-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "wms-envio-devolucion-mayoreo-editar",
          params: { id: current.id },
        });
      }
    },
  },
};
</script>
